// EVENT ANALYTICS - CONSTANTS
export const FEEDBACK_EVENT_TYPE = 'gradebook.feedbackEvent';
export const ANALYTICS_EVENT_TYPE = 'gradebook.analyticsEvent';
export const FEEDBACK_EVENT_ORIGIN = 'gradebookFrontend';

// EVENT LOCATIONS
export const EVENT_LOCATION_GB = 'Instructor Gradebook';
export const EVENT_LOCATION_GB_SEARCH = 'Gradebook Search';
export const EVENT_LOCATION_GB_UNITS = 'Gradebook Units';
export const EVENT_LOCATION_GB_PAGINATION = 'Gradebook Pagination';
export const EVENT_LOCATION_GB_EXPORT = 'Gradebook Export Modal';
export const EVENT_LOCATION_GB_SETTINGS = 'Gradebook Settings';
export const EVENT_LOCATION_GB_MANUAL_ASSIGNMENT =
  'Gradebook Add Manual Assignment';
export const EVENT_LOCATION_GB_GRADE_MODAL = 'Gradebook Override Grade Dialog';
export const EVENT_LOCATION_GB_ICLICKER_MODAL = 'Gradebook Sync iClicker Modal';
export const EVENT_LOCATION_ISG_UNITS = 'Individual Student Gradebook Units';

// EVENTS
export const openGradebook = (courseId) => ({
  action: 'view',
  target: 'Gradebook',
  loc: EVENT_LOCATION_GB,
  course_id: courseId,
});

export const clickGradebookSearch = (courseId, searchType) => ({
  action: 'click',
  target: 'Gradebook ' + searchType + ' Search',
  loc: EVENT_LOCATION_GB_SEARCH,
  course_id: courseId,
});

export const togglePointOrGrade = (courseId, unit) => ({
  action: 'toggle',
  target: 'Gradebook - toggle ' + unit,
  loc: EVENT_LOCATION_GB_UNITS,
  course_id: courseId,
});

export const isgTogglePointOrGrade = (courseId, unit) => ({
  action: 'toggle',
  target: 'Individual Student Gradebook - toggle ' + unit,
  loc: EVENT_LOCATION_ISG_UNITS,
  course_id: courseId,
});

export const clickPagination = (courseId, selected) => ({
  action: 'click',
  target: 'Gradebook Page Number',
  loc: EVENT_LOCATION_GB_PAGINATION,
  value: selected,
  course_id: courseId,
});

export const clickExportGradebook = (courseId) => ({
  action: 'click',
  target: 'Export Gradebook',
  loc: EVENT_LOCATION_GB_EXPORT,
  course_id: courseId,
});

export const addManualAssignment = (courseId) => ({
  action: 'click',
  target: 'Add a Non-Achieve Assignment',
  loc: EVENT_LOCATION_GB_MANUAL_ASSIGNMENT,
  course_id: courseId,
});

export const changeGradingType = (courseId) => ({
  action: 'click',
  target: 'Grading Type Toggle',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const changeGradeDisplay = (courseId) => ({
  action: 'click',
  target: 'Grade Display Toggle',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const clickAddCategory = (courseId) => ({
  action: 'click',
  target: 'Gradebook Add Category',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const clickRemoveCategory = (courseId) => ({
  action: 'click',
  target: 'Gradebook Remove Category',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const clickReportInProgressWork = (courseId) => ({
  action: 'click',
  target: 'Report In Progress Work Toggle',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const clickRequireStudentId = (courseId) => ({
  action: 'click',
  target: 'Require Student ID Checkbox',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const clickSaveGradebookSettings = (courseId) => ({
  action: 'click',
  target: 'Save Gradebook Settings',
  loc: EVENT_LOCATION_GB_SETTINGS,
  course_id: courseId,
});

export const clickStudentName = (courseId) => ({
  action: 'click',
  target: 'Gradebook Student Name',
  loc: EVENT_LOCATION_GB,
  course_id: courseId,
});

export const clickStudentGrade = (courseId) => ({
  action: 'click',
  target: 'Gradebook Student Grade',
  loc: EVENT_LOCATION_GB,
  course_id: courseId,
});

export const viewStudentAssignment = (courseId) => ({
  action: 'click',
  target: '"View Student Assignment" Link',
  loc: EVENT_LOCATION_GB_GRADE_MODAL,
  course_id: courseId,
});

export const viewAssignmentReport = (courseId) => ({
  action: 'click',
  target: '"View Assignment Report" Link',
  loc: EVENT_LOCATION_GB_GRADE_MODAL,
  course_id: courseId,
});

const getGradeChanges = (hasGradeComment, hasGradeOverride) => {
  let gradeChanges = 'No Changes';
  if (hasGradeComment && hasGradeOverride) {
    gradeChanges = 'Change Student Score and Add Note for Student';
  }
  if (hasGradeComment && !hasGradeOverride) {
    gradeChanges = 'Add Note for Student';
  }
  if (!hasGradeComment && hasGradeOverride) {
    gradeChanges = 'Change Student Score';
  }
  return gradeChanges;
};

export const clickSaveGradeChanges = (
  courseId,
  hasGradeComment,
  hasGradeOverride,
) => ({
  action: 'save',
  target: getGradeChanges(hasGradeComment, hasGradeOverride),
  loc: EVENT_LOCATION_GB_GRADE_MODAL,
  course_id: courseId,
});

export const syncIClicker = (courseId) => ({
  action: 'click',
  target: 'Gradebook iClicker Course Linked',
  loc: EVENT_LOCATION_GB_ICLICKER_MODAL,
  course_id: courseId,
});
